<template>
    <div class="container domainsConfig weflix-admin-domain">
        <TitlePage title="Configurações de Domínio" subtitle="Gerencie os domínios do seu sistema Weflix" :hasMargin="false" />
        <div class="col-form-outer col-12 col-md-12 col-lg-12 col-12" v-if="hasReady">
            <div class="row">

            <div class="info_domain">
                <div class="info_domain">
                    <h5>Domínio Weflix</h5>
                    <small>O Weflix cria, automaticamente, um dominio baseado no nome da sua loja. ATENÇÃO: Ao atualizar o domínio, você será redirecionado e será necessário fazer login novamente. O tempo de propagação de suas alterações pode ser de até 20 minutos.</small>
                </div>
                <div class="form-group flex domain" >
                <div class="form-group col-md-6 col-lg-6 col-6">
                    <div class="form-label">
                      <label>Nome do Domínio Weflix</label>
                    </div>
                    <div class="form-input">
                      <div class="flex domain_input" style="position:relative;">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Meu Domínio"
                        v-model="domainWeflix"
                        @keyup="createFullDomain()"
                      />
                      <fa icon="fa-check icon_check" v-if="hasValidDomain==true"/>
                      <fa icon="fa-times icon_check" v-if="hasValidDomain==false"/>
                      
                      <button class="btn verify" @click="verifyDomain">Verificar</button>
                    </div>
                      <small class="small">Apenas texto, sem espaços ou caracteres especiais. Limite de 30 caracteres.</small>

                    </div>
                </div>
                <div class="domainPreview col-md-6 col-lg-6 col-6">
                  <div class="form-label">
                    <label>Domínio Final Weflix</label>
                  </div>
                  <div class="form-input" style="position:relative;">
                    <input
                      type="text"
                      class="form-control disabled"
                      placeholder="https://www.seudominio.weflix.com.br"
                      v-model="fullDomainWeflix"
                      disabled
                    />
                    <small class="small">Domínio que será visto pelos usuários.</small>

                    <span class="iconCopy" @click="copyToClipboard(fullDomainWeflix)"><i class="pi pi-copy"></i></span>
                  </div>
                </div>
              </div>
                 

            </div>
        <hr/>
            <div class="info_domain">
                <h5>Domínio Próprio</h5>
                <small>O Weflix permite que você use um domínio próprio para sua loja. Para isso, é necessário configurar um apontamento CNAME no seu provedor de domínio.

                  ATENÇÃO: Após atualizar o domínio, você será redirecionado e precisará fazer login novamente. O tempo de propagação das suas alterações pode levar até 24 horas.</small>
            </div>

            <div class="form-group flex domain">
              <div class="col-form-inner col-6 col-md-6 col-lg-6 ">
                <div class="form-group">
                  <div class="form-label">
                    <label>Domínio Primário</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                        placeholder="https://www.seudominio.com.br"
                      v-model="domainPrimary"
                    />
                    <small class="small">Domínio primário para acesso.</small>

                  </div>
                </div>
              </div>

              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Domínio Adicional</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="https://www.seudominio.com.br"
                      v-model="domainSecondary"
                    />
                    <small class="small">Domínio secundário para acesso.</small>

                  </div>
                </div>
              </div>
            </div>
           

            

              <div class="info_pointer">
                <div class="CNAME">
                  <small>No seu provedor, selecione o registro CNAME e aponte para o endereço:</small>
                  <div class="form-input small" style="position:relative;">
                    <input
                      type="text"
                      class="form-control disabled cname"
                      placeholder="app.weflix.com.br"
                      disabled
                    />
                    <span class="iconCopy"><i class="pi pi-copy"></i></span>
                    
                  </div>
                </div>
                <div class="A">
                  <small>Você pode também apontar seu domínio root, Selecione o Registro A em seu provedor e aponte para os IPs:</small>

                  <div class="form-input small" style="position:relative;">
                    <input
                      type="text"
                      class="form-control disabled ip"
                      placeholder="35.174.239.148"
                      v-model="title"
                      disabled
                    />
                    
                    <span class="iconCopy"><i class="pi pi-copy"></i></span>
                  </div>
                  <div class="form-input small" style="position:relative;">
                    <input
                      type="text"
                      class="form-control disabled ip"
                      placeholder="54.208.52.130"
                      v-model="dns2"
                      disabled
                    />
                    <span class="iconCopy"><i class="pi pi-copy"></i></span>
                  </div>
                </div>
             </div>

             <div class="info_doubt">
              <small>Caso esteja com difuculdade em realizar os apontamentos, siga nosso tutorial <a href="">clicando aqui</a>.</small>
             </div>


            </div>
          </div>
        <div class="d-flex justify-content-center justify-content-md-end mt-5 mt-md-8 pb-2 pb-md-4">
            <!-- <button class="btn" @click="(()=>this.$router.push('/admin/colecao/1'))">Cancelar</button> -->
            <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="editDomain">Salvar</v-btn>
        </div>
      </div>
<Loader :hasReady="hasReady" />
</template>

<script>
import apiDomain from '@/utils/Weflix/domain';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader';
import apiWebsite from '@/utils/Weflix/website';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
    data(){
        return{
            domainWeflix: '',
            fullDomainWeflix: '',
            domainPrimary: '',
            domainSecondary: '',
            hasReady: false,
            hasData: false,
            hasValidDomain: null,
        }
    },
    computed: {
        ...mapState(['token'])
    },
    components: {
        Loader,
        TitlePage
    },
    methods: {
        async getDomain(){
            try {
                const response = await apiDomain.getDomain(this.token);
                this.hasReady = true;
                this.domainWeflix = response.url.replace('https://', '').split('.')[0];
                this.fullDomainWeflix = response.url;
                this.domainPrimary = response.url1;
                this.domainSecondary = response.url2;
                this.hasdata = response.url != null || response.url != '' ? true : false;
            } catch (error) {
                console.error('Erro ao obter dados do dominio:', error);
            }
        },
        async editDomain(){
          this.hasReady = false;
          const payload = {
            "url": this.hasData == true ? this.domainWeflix : 'https://'+this.domainWeflix+'.weflix.com.br',
            "url1": this.domainPrimary,
            "url2": this.domainSecondary
          }
          try {
            const response = await apiDomain.editDomain(this.token, payload);
            this.hasReady = true;
            this.notify('Domínio atualizado com sucesso!', 'success');
          } catch (error) {
            
        }
    },
    createFullDomain(){
        if (this.domainWeflix) {
            // Remove todos os caracteres não alfanuméricos e espaços
            this.domainWeflix = this.domainWeflix.replace(/[^\w\s]/gi, '').replace(/\s+/g, '').toLowerCase();
            
            // Concatena o domínio base com o nome do domínio fornecido pelo usuário
            this.fullDomainWeflix = 'https://'+this.domainWeflix+'.weflix.com.br';
        } else {
            console.error('domainWeflix está undefined');
        }
    },
    async verifyDomain(){
      const payload = {
        url: this.fullDomainWeflix
      }
      try {
        const response = await apiWebsite.verifyDomaintData(this.token, payload);
        this.hasValidDomain = response;
      } catch (error) {
        console.error('Erro ao verificar dominio:', error);
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
  },  
    created(){
        this.getDomain();
    }
  }
  
</script>

<style scoped lang="scss">
@import url('./css/domains.css');
.container.container.domainsConfig.weflix-admin-domain {
    width: 100%;
  max-width: 100%;
}
</style>
